export const getCartonStatusBadge = (status) => {
  const map = {
    RECEIVED: 'badge-yellow', SORTING: 'badge-purple',
    REGISTERED: 'badge-blue', GROUPED: 'badge-cyan',
    PACKED: 'badge-cyan', DEPARTED: 'badge-blue',
    IN_TRANSIT: 'badge-purple', ARRIVED_BD: 'badge-yellow',
    IN_BD_WAREHOUSE: 'badge-green', DELIVERED: 'badge-green',
  };
  return map[status] || 'badge-gray';
};

export const getShipmentStatusBadge = (status) => {
  const map = {
    CREATED: 'badge-gray', PACKING: 'badge-yellow',
    READY: 'badge-blue', DEPARTED: 'badge-purple',
    IN_TRANSIT: 'badge-cyan', ARRIVED: 'badge-yellow',
    COMPLETED: 'badge-green',
  };
  return map[status] || 'badge-gray';
};

export const getProductStatusBadge = (status) => {
  const map = {
    RECEIVED: 'badge-yellow',
    SORTING: 'badge-purple',
    PARTIALLY_PACKED: 'badge-cyan',
    FULLY_PACKED: 'badge-green',
  };
  return map[status] || 'badge-gray';
};

export const getConditionBadge = (condition) => {
  const map = {
    GOOD: 'badge-green',
    DAMAGED: 'badge-red',
    PARTIAL: 'badge-yellow',
  };
  return map[condition] || 'badge-gray';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
};

export const getRoleLabel = (role) => {
  const map = {
    SUPER_ADMIN: 'Super Admin', CHINA_STAFF: 'China Staff',
    BD_STAFF: 'BD Staff', CUSTOMER: 'Customer',
  };
  return map[role] || role;
};

export const getRoleBadge = (role) => {
  const map = {
    SUPER_ADMIN: 'badge-red', CHINA_STAFF: 'badge-blue',
    BD_STAFF: 'badge-green', CUSTOMER: 'badge-purple',
  };
  return map[role] || 'badge-gray';
};
